import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import SvgIcon from '../svg-icon';

import * as AppActionCreators from '../../redux/action';
import InfoModalSC from './info-modal.styled';
import svgIconCheck from '../../assets/svg/success-modal-tile.svg';
import svgIconCross from '../../assets/svg/error-modal-tile.svg';

class InfoModal extends React.PureComponent {
  render() {
    const { modalData, toggleInfoModal } = this.props;
    // do not render it
    if (!modalData.isOpen) return null;

    const { type, message } = modalData;
    const svgIcon = type === 'success' ? svgIconCheck : svgIconCross;

    return (
      <Modal
        open={modalData.isOpen}
        onClose={toggleInfoModal}
        classNames={{
          modal: 'info-modal',
          overlay: 'info-overlay',
          closeButton: 'info-modal__close-btn'
        }}
      >
        <InfoModalSC type={type}>
          <div className="wrapper">
            <div className="svg-wrapper">
              <SvgIcon icon={svgIcon} alt="type_icon" />
            </div>
            <p>{message}</p>
            {modalData.callback.fnc !== null ? (
              <button onClick={() => modalData.callback.fnc()} type="button">
                {modalData.callback.btnText}
              </button>
            ) : null}
          </div>
        </InfoModalSC>
      </Modal>
    );
  }
}

InfoModal.propTypes = {
  modalData: PropTypes.shape({
    type: PropTypes.string,
    isOpen: PropTypes.bool,
    message: PropTypes.string,
    callback: PropTypes.shape({
      btnText: PropTypes.string,
      fnc: PropTypes.func
    })
  }).isRequired,
  toggleInfoModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  modalData: state.ui.infoModal
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleInfoModal: AppActionCreators.toggleInfoModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoModal);
